import type { IExtractRouteParamMap } from "@/routes/types";
import { createPaths } from "@/routes/utils";

const baseRoute = `/student/settings`;

export const studentSettingsRoutesObj = {
  home: baseRoute,
  editProfile: `${baseRoute}/edit-profile`,
  changePassword: `${baseRoute}/change-password`,
  changePhoneNumber: `${baseRoute}/change-phone-number`,
  privacyPolicy: `${baseRoute}/privacy-policy`,
  deleteAccount: `${baseRoute}/delete-account`,
} as const;

export type IStudentSettingsRouteParams = IExtractRouteParamMap<
  typeof studentSettingsRoutesObj
>;

export const studentSettingsPath = createPaths<
  typeof studentSettingsRoutesObj,
  IStudentSettingsRouteParams
>(studentSettingsRoutesObj);
